import axios, { AxiosHeaders } from "axios";
import queryString from 'query-string';

export const client = axios.create({
    baseURL: "/",
    transformRequest: [(data: string | {}, headers: AxiosHeaders) => {
        const authData = localStorage.getItem("ts:auth");
        const accessToken = authData ? JSON.parse(authData)?.accessToken : null;
        const nameData = localStorage.getItem("ts:appName") || "";

        // const headers = new Headers();

        // headers.set("Content-Type", 'application/json')
        // headers.set("Authorization", `Bearer ${accessToken}`)
        // headers.set("X-Tradecore-App-Name", nameData);

        headers.Authorization = accessToken ? `Bearer ${accessToken}` : undefined;
		headers['Content-Type'] = 'application/json';
		headers['X-Tradecore-App-Name'] = nameData;

        return typeof data === 'string' ? data : JSON.stringify(data)
    }],
    responseType: 'json'
});

export const oauthClient = axios.create({
	baseURL: `${process.env.REACT_APP_API_URL}/v1`,
	transformRequest: [(data, headers) => {
		headers['Content-Type'] = 'application/x-www-form-urlencoded';
		return queryString.stringify(data);
	}],
	responseType: 'json',
});

export const cardClient = axios.create({
	baseURL: `${process.env.REACT_APP_API_URL}/cards/v1`,
	transformRequest: [(data, headers) => {
		const authData = localStorage.getItem('@Auth:auth');
		const accessToken = authData ? JSON.parse(authData).accessToken : undefined;
		const nameData = localStorage.getItem('@Auth:appName');
		headers.Authorization = accessToken ? `Bearer ${accessToken}` : undefined;
		headers['Content-Type'] = 'application/json';
		headers['X-Tradecore-App-Name'] = nameData;
		return typeof data === 'string' ? data : JSON.stringify(data);
	}],
	responseType: 'json',
});

export const v2client = axios.create({
	baseURL: `${process.env.REACT_APP_API_URL}/v2`,
	transformRequest: [(data, headers) => {
		const authData = localStorage.getItem('@Auth:auth');
		const accessToken = authData ? JSON.parse(authData).accessToken : undefined;
		const nameData = localStorage.getItem('@Auth:appName');
		headers.Authorization = accessToken ? `Bearer ${accessToken}` : undefined;
		headers['Content-Type'] = 'application/json';
		headers['X-Tradecore-App-Name'] = nameData;
		return typeof data === 'string' ? data : JSON.stringify(data);
	}],
	responseType: 'json',
});

export const bankClient = axios.create({
	baseURL: `${process.env.REACT_APP_API_URL}/digital-bank`,
	transformRequest: [(data, headers) => {
		const authData = localStorage.getItem('@Auth:auth');
		const accessToken = authData ? JSON.parse(authData).accessToken : undefined;
		const nameData = localStorage.getItem('@Auth:appName');
		headers.Authorization = accessToken ? `Bearer ${accessToken}` : undefined;
		headers['Content-Type'] = 'application/json';
		headers['X-Tradecore-App-Name'] = nameData;
		return typeof data === 'string' ? data : JSON.stringify(data);
	}],
	responseType: 'json',
});

// TO DO: add interceptors for each client